export default __webpack_public_path__ + "static/media/how-2@2x.02b1b092.png";